import styled from 'styled-components';

const NoteContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 0.5rem;

    & > *:not(:last-child) {
        margin-right: 0.5rem;
    }
`;

export default NoteContainer;
